import IntroSection from './IntroSection'

export default IntroSection
